import { httpClient } from './httpClient';

export const fetchPlanslist = async () => {
  const response = await httpClient.get('/plans/list');
  return response.data;
};

export const fetchPlanscreate = async (payload) => {
  const response = await httpClient.post('/plans/create', payload);
  return response.data;
};

export const getCompanyPlans = async (companyId) => {
  const response = await httpClient.get(`/plans/${companyId}`);
  return response.data;
};

export const getPlanMemberSettings = async (priceId) => {
  const response = await httpClient.get('/plans/member-settings', {
    params: { price_id: priceId },
  });
  return response.data;
};

export const getPlan = async (planId) => {
  const response = await httpClient.get(`/plans/show/${planId}`);
  return response.data;
};

export const updatePlan = async (planId, data) => {
  const response = await httpClient.put(`/plans/${planId}`, data);
  return response.data;
};
